import { kevinAuthAPI } from 'apis/config';
import { useQuery } from '@tanstack/react-query';
import { handleMessage } from '../../utils/helper/message';
import { message } from 'antd';

export const userApi = {
  signup: (
    email: string,
    password: string,
    passwordConfirm: string,
    organizationName: string,
  ) =>
    kevinAuthAPI
      .post(`/account`, {
        email,
        password,
        passwordConfirm,
        organizationName,
      })
      .then((res) => res.data)
      .catch((error) => error),
  init: (
    organizationName: string,
    email: string,
    password: string,
    passwordConfirm: string,
  ) =>
    kevinAuthAPI
      .post(`/organization`, {
        email,
        password,
        passwordConfirm,
        organizationName,
      })
      .then((res) => res.data)
      .catch((error) => error),
  checkOrganization: (organizationName: string) =>
    kevinAuthAPI
      .post(`/organization/check`, {
        organizationName: organizationName,
      })
      .then((res) => res.data)
      .catch((error) => error),
  fetchOrganizationUsers: (organizationName: string) =>
    kevinAuthAPI
      .get(`/organization/${organizationName}/users`)
      .then((res) => res.data)
      .catch((error) => error),
  fetchProjectUsers: (organizationName: string, projectId: number) =>
    kevinAuthAPI
      .get(`/organization/${organizationName}/${projectId}/users`)
      .then((res) => res.data)
      .catch((error) => error),
  changeProjectUsers: (
    organizationName: string,
    projectId: number,
    ids: number[],
  ) =>
    kevinAuthAPI
      .post(
        `/organization/${organizationName}/${projectId}/change-project-users`,
        {
          ids,
        },
      )
      .then((res) => res.data)
      .catch((error) => error),
  login: (email: string, password: string) =>
    kevinAuthAPI
      .post(`/account/login`, {
        email,
        password,
      })
      .then((res) => res.data)
      .catch((error) => error),
  verify: (email: string | undefined, code: string) =>
    kevinAuthAPI
      .post(`/account/verify`, {
        email,
        code,
      })
      .then((res) => res.data)
      .catch((error) => error),
};

export const queryFetchOrganizationUsers = (organizationName: string) => {
  const { data, error, isLoading, isError } = useQuery(
    ['organizationUsers', organizationName], // 쿼리 키
    () => userApi.fetchOrganizationUsers(organizationName), // 데이터를 가져오는 함수
    {
      // 선택적 옵션
      onError: (error) => {
        handleMessage(message, 'error', JSON.stringify(error));
      },
    },
  );

  return { data, error, isLoading, isError };
};

export const queryFetchProjectUsers = (
  organizationName: string,
  projectId: number,
) => {
  const { data, error, isLoading, isError } = useQuery(
    ['projectUsers', organizationName, projectId], // 쿼리 키
    () => userApi.fetchProjectUsers(organizationName, projectId), // 데이터를 가져오는 함수
    {
      // 선택적 옵션
      onError: (error) => {
        handleMessage(message, 'error', JSON.stringify(error));
      },
    },
  );

  return { data, error, isLoading, isError };
};
